import { MEDIA_QUERIES } from '../constants/media-queries/mediaQueries';

export function isMobileScreenSize() {
  return window.matchMedia(MEDIA_QUERIES.L_DOWN).matches;
}
